import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import io from 'socket.io-client';

const WebSocketContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL.replace(/^https/, 'wss').replace(/^http/, 'ws');

export const WebSocketProvider = ({ children }) => {
  const [sockets, setSockets] = useState({});

  const connectToAuction = useCallback((auctionId, onMessage) => {
    if (sockets[auctionId]) {
      return sockets[auctionId];
    }

    const ws = new WebSocket(`${BACKEND_URL}/ws/auction/${auctionId}`);
    
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      onMessage(data);
    };

    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    setSockets(prev => ({ ...prev, [auctionId]: ws }));
    return ws;
  }, [sockets]);

  const disconnectFromAuction = useCallback((auctionId) => {
    if (sockets[auctionId]) {
      sockets[auctionId].close();
      setSockets(prev => {
        const newSockets = { ...prev };
        delete newSockets[auctionId];
        return newSockets;
      });
    }
  }, [sockets]);

  useEffect(() => {
    return () => {
      Object.values(sockets).forEach(socket => socket.close());
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ connectToAuction, disconnectFromAuction }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
};